"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StandardActionTypes;
(function (StandardActionTypes) {
    StandardActionTypes["CREATE"] = "create";
    StandardActionTypes["CREATE_SUCCESS"] = "create success";
    StandardActionTypes["CREATE_FAIL"] = "create fail";
    StandardActionTypes["UPDATE"] = "update";
    StandardActionTypes["UPDATE_SUCCESS"] = "update success";
    StandardActionTypes["UPDATE_MANY"] = "update many";
    StandardActionTypes["UPDATE_MANY_SUCCESS"] = "update many success";
    StandardActionTypes["DELETE"] = "delete";
    StandardActionTypes["DELETE_SUCCESS"] = "delete success";
    StandardActionTypes["LOAD_ALL"] = "load all";
    StandardActionTypes["LOAD_MANY_SUCCESS"] = "load all success";
    StandardActionTypes["LOAD_ONE"] = "load one";
    StandardActionTypes["LOAD_ONE_SUCCESS"] = "load one success";
    StandardActionTypes["ENTITY_ERROR"] = "entity error";
})(StandardActionTypes = exports.StandardActionTypes || (exports.StandardActionTypes = {}));
//# sourceMappingURL=actions-types.enum.js.map